import { createEffect, createSignal } from "solid-js"
import createSharedCachedFactory from "../../../rx/memo/createSharedCachedFactory"
import type { Engine } from "../../core/engine/Engine.type"
import { isPlainObjDeeplyEqual } from "../../isPlainObjDeeplyEqual"
import type { QuadrantBound } from "../../Quadtree/createEntityQuadtreeEffect"

export const useRootQuadrantBound = createSharedCachedFactory((
  engine: Engine,
) => {
  function getValue() {
    const { width, height } = engine.state
    return {
      x: 0,
      y: 0,
      width,
      height,
    }
  }
  const [getter, setter] = createSignal<QuadrantBound>(getValue(), {
    equals: isPlainObjDeeplyEqual
  })
  createEffect(() => {
    // console.log('useQuadrantBound.effect', getValue())
    setter(getValue())
  })
  return getter
})
